import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";
import { URL } from "../config";

const AddPackageTypeModal = ({ onClose, packagetype }) => {
  const [packageTypeName, setPackageTypeName] = useState(
    packagetype?.packageTypeName || ""
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPackageTypeName(packagetype?.packageTypeName || "");
  }, [packagetype]);

  const handleSubmit = async () => {
    if (!packageTypeName.trim()) {
      toast.error("Please enter package type name!");
      return;
    }

    setLoading(true);
    try {
      if (packagetype) {
        await axios.patch(
          `${URL}/packagetypes/${packagetype.packageTypeId}`,
          { packageTypeName }
        );
        toast.success("Package type updated successfully!");
      } else {
        await axios.post(`${URL}/packagetypes`, { packageTypeName });
        toast.success("Package type added successfully!");
      }
      setTimeout(() => onClose?.(), 500);
    } catch (err) {
      console.error(err);
      toast.error("Operation failed!");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      minHeight: "28px",
      fontSize: "14px",
      "& fieldset": { borderColor: "#c4c4c4" },
      "&:hover fieldset": { borderColor: "#184459ff" },
      "&.Mui-focused fieldset": {
        borderColor: "#c4c4c4",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "18px",
      color: "#184459ff",
      fontWeight: 600,
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#184459ff" },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
        p: 2,
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", sm: 400 },
          bgcolor: "#fff",
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "#184459ff", mb: 2 }}
        >
          {packagetype ? "Edit Package Type" : "Add Package Type"}
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Package Type Name"
            size="small"
            value={packageTypeName}
            onChange={(e) => setPackageTypeName(e.target.value)}
            sx={fieldStyle}
            InputLabelProps={{ shrink: true }}
          />

          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#184459ff",
                "&:hover": { backgroundColor: "#184459ff" },
              }}
              onClick={handleSubmit}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : packagetype ? "Update" : "Save"}
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#757575ff",
                "&:hover": { backgroundColor: "#757575ff" },
              }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default AddPackageTypeModal;
